"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const EuroCirculoM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== "auto") {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "-8 -8 720 720" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M351.3 659.7c204.6 0 308.4-103.7 308.4-308.2 0-204.7-103.7-308.4-308.4-308.4-204.5 0-308.2 103.7-308.2 308.4 0 204.5 103.7 308.2 308.2 308.2zm0-659.7c229.9 0 351.5 121.5 351.5 351.5 0 229.8-121.5 351.3-351.5 351.3C121.5 702.8 0 581.3 0 351.5 0 121.5 121.5 0 351.3 0zm138.6 494.7c10.7-5.1 23.5-.6 28.6 10.1 0 .1.1.1.1.2 5.1 10.7.5 23.6-10.3 28.7h-.1c-30.8 14.5-68.2 21.8-111.3 21.8-111.9 0-183.1-49.9-206.3-142.1h-40c-11.9 0-21.6-9.6-21.6-21.6s9.6-21.6 21.6-21.6h33.1c-.9-9.8-1.3-19.5-1.4-29.3 0-4.4.3-8.6.5-12.9h-32.2c-11.9-.4-21.2-10.4-20.7-22.3.4-11.3 9.5-20.3 20.7-20.7h36.7c18.6-102.8 91.3-158.7 209.7-158.7 42.5 0 79.6 7.1 110.1 21.3 10.8 5 15.5 17.8 10.5 28.6s-17.8 15.5-28.6 10.5c-24.8-11.5-55.8-17.3-92-17.3-94.6 0-148.8 38.4-165.4 115.6h130.8c11.9 0 21.5 9.6 21.5 21.5s-9.6 21.5-21.5 21.5h-136c-.2 4.4-.8 8.3-.8 12.9 0 10.5 1 19.9 1.9 29.3h135.1c11.9 0 21.6 9.6 21.6 21.6s-9.6 21.6-21.6 21.6H235.4c20.6 66.3 73.8 99 161.6 99 36.7.1 67.9-5.9 92.9-17.7z" }))));
};
exports.default = EuroCirculoM;
//# sourceMappingURL=index.js.map